var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMNft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.714 11.0377C46.6251 14.3357 50.997 17.9999 50.997 17.9999C50.997 17.9999 55.5735 13.9676 57.28 11.0377C59.2099 7.7242 59.997 1.84084 59.997 1.84084C59.997 1.84084 56.5583 0 50.997 0C45.4357 0 41.9971 1.84084 41.9971 1.84084C41.9971 1.84084 42.9222 7.94543 44.714 11.0377Z",
    fill: "#FEA005"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4999 11.2499L44.9998 22.4972V48.7524L22.4999 59.9997L0 48.7524V22.4972L22.4999 11.2499Z",
    fill: "#FEA005"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMNft);
export default __webpack_public_path__ + "static/media/m_nft.31bb92061f34a884fb2dfb3120b38fe2.svg";
export { ForwardRef as ReactComponent };